import { useEffect, useState } from 'react'
import { Box, Button, CircularProgress, InputAdornment, TextField, Typography } from '@mui/material';
import {
  sxButtonGerarBoleto,
  sxSubtitle,
  sxSubtitleBold,
  sxValorTotal,
  sxCodigoDeBarrasValor,
  sxButtonCopiarCodigoOutlined,
  sxLabelDataPagamento
} from './sxProps';
import { faCalendar } from '@fortawesome/pro-duotone-svg-icons';
import './styles.css'
import {
  getBoletoSegundaViaInadimplente,
  getBoletoSegundaViaSelecaoTitulos,
  getBoletoSegundaViaEnviar
} from '../../../services/FinanceiroService'
import { base64toBlob } from '../../../utils/Base64ToBlob';
import { SegundaViaBoletoSelecaoTitulosInfo } from '../../../interfaces/entities/SegundaViaBoletoSelecaoTitulosInfo';
import { Fatura } from '../../../interfaces/entities/Fatura';
import { ParcelaBoleto } from '../../../interfaces/entities/ParcelaBoleto';
import { TypeBoletoSegundaVia } from '../../../interfaces/enum/TypeBoletoSegundaVia';
import TabelaFaturas from './TabelaParcelas';
import { formatNumberToReais, formatStringToReais } from "../../../utils/MoneyFormat";
import LoadingApp from '../../../components/LoadingApp';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { dateMask } from '../../../utils/DateMask';
import CalendarModal from './CalendarModal';
import ModalFeedBack from '../../../components/ModalFeedBack';
import { getPermissaoSegundaViaBoleto } from '../../../services/PermissoesService';
import { useAccessibility } from '../../../Store/contexts/AccessibilityContext';
import AdviceContainer from '../../../components/AdviceContainer';
import { TextTypeEnum } from '../../../interfaces/enum/TextTypeEnum';
import AudioLoadingDescription from '../../../components/Accessibility/AudioLoadingDescription';
import CircularProgressLoading from '../../../components/Accessibility/CircularProgressLoading';
import PageTitle from '../../../components/Accessibility/PageTitle';
import { isNewSegundaViaBoletoActive } from '../../../utils/featureFlags';
import SegundaViaBoletoNovo from './SegundaViaBoletoNovo';

function SegundaViaBoletoLegado() {
  const [info, setInfo] = useState<SegundaViaBoletoSelecaoTitulosInfo | null>(null);
  const [permiteEmissao, setPermiteEmissao] = useState<boolean>(true);
  const [boleto, setBoleto] = useState<Fatura | null>(null);
  const [parcelas, setParcelas] = useState<ParcelaBoleto[]>([]);
  const [adviceTextMessage, setAdviceTextMessage] = useState<string>('');
  const [tipoBoleto, setTipoBoleto] = useState<TypeBoletoSegundaVia>(TypeBoletoSegundaVia.Vazio);
  const [index, setIndex] = useState<number>(0);
  const [data, setData] = useState<string>(moment().format('DD/MM/YYYY'));
  const [dataDigitada, setDataDigitada] = useState<string>(moment().format('DD/MM/YYYY'))
  const [showCalendarModal, setShowCalendarModal] = useState<boolean>(false);
  const [loadingData, setLoadingData] = useState<boolean>(false);
  const [loadingSelecaoParcelas, setLoadingSelecaoParcelas] = useState<boolean>(false);
  const [loadingBoleto, setLoadingBoleto] = useState<boolean>(false);
  const [valorTotal, setValorTotal] = useState<number>(0);
  const [errorModal, setErrorModal] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>('');

  const accessibility = useAccessibility();

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    setLoadingData(true);
    try {
      const permiteEmissao = await getPermissaoSegundaViaBoleto();
      setPermiteEmissao(permiteEmissao);
      if (permiteEmissao) {
        loadParcelas();
      } else {
        setLoadingData(false);
      }
    } catch (e) {
      console.log('error', e);
      setLoadingData(false);
      setPermiteEmissao(false);
      setErrorMessage('Erro ao buscar permissão');
      setErrorModal(true);
    }

  }

  const loadParcelas = () => {
    setLoadingData(true);
    getBoletoSegundaViaInadimplente()
      .then(response => {
        setTipoBoleto(response.tipo);
        if (response.tipo === TypeBoletoSegundaVia.Unico) {
          setBoleto(response.boleto);
        } else if (response.tipo === TypeBoletoSegundaVia.Parcelas) {
          setInfo(response.info);
          setParcelas(response.parcelas ? response.parcelas : []);
          setAdviceTextMessage(response.msg2);
          const index = response.parcelas ? response.parcelas.length - 1 : 0;
          setIndex(index);
          loadSelecaoParcelas(response.info, index + 1, moment().format('DD/MM/YYYY'));
        } else if (response.tipo === TypeBoletoSegundaVia.Erro) {
          setErrorMessage(response.mensagem);
          setErrorModal(true);
        }
      })
      .catch(error => {
        console.log('error', error);
        setTipoBoleto(TypeBoletoSegundaVia.Erro);
        setErrorMessage(error?.mensagem || 'Erro ao carregar boletos');
        setErrorModal(true);
      })
      .finally(() => {
        setLoadingData(false)
      })
  }

  const gerarBoletoParcelas = () => {
    if (info !== null) {
      setLoadingBoleto(true);
      getBoletoSegundaViaEnviar(info, index, data)
        .then(response => {
          console.log(response);
          if (response.boleto) {
            const pdf = response.boleto.pdf;
            abrirPdf(pdf);
          }
        })
        .catch((error: any) => {
          setErrorModal(true);
          setErrorMessage(error.msgs || 'Erro ao gerar boleto');
        })
        .finally(() => {
          setLoadingBoleto(false);
        })
    }
  }

  const loadSelecaoParcelas = (info: SegundaViaBoletoSelecaoTitulosInfo | null, index: number, data: string) => {
    setLoadingSelecaoParcelas(true);
    if (info !== null) {
      getBoletoSegundaViaSelecaoTitulos(info, index, data)
        .then(response => {
          setValorTotal(response);
        })
        .catch(error => {
          console.log(error);
          setErrorModal(true);
          setErrorMessage('Erro ao calcular valor total');
        })
        .finally(() => {
          setLoadingSelecaoParcelas(false);
        })
    }
  }

  const gerarBoletoUnico = () => {
    if (boleto && boleto.pdf !== null) {
      setLoadingBoleto(true);
      abrirPdf(boleto.pdf);
      setLoadingBoleto(false);
    }
  }

  const abrirPdf = (pdf: string) => {
    const blob = base64toBlob(pdf.split(',')[1]);
    const blobUrl = URL.createObjectURL(blob);
    window.open(blobUrl);
  }

  const handleDateChange = (date: string) => {
    setData(date);
    setIndex(parcelas.length);
    loadSelecaoParcelas(info, parcelas.length, date);
  }

  const handleDateTyped = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const dateString = dateMask(event.target.value)
    setDataDigitada(dateString);

    if (moment(dateString, 'DD/MM/YYYY', true).isValid() === true) {
      handleDateChange(dateString);
    }
  };

  const handlePickDate = (date: string) => {
    setShowCalendarModal(false);
    setDataDigitada(dateMask(date));
    handleDateChange(date);
  }

  const handleIndexChange = (selectedIndex: number) => {
    if (selectedIndex > index) {
      setIndex(selectedIndex);
      loadSelecaoParcelas(info, selectedIndex, data);
    } else {
      setIndex(selectedIndex - 1);
      loadSelecaoParcelas(info, selectedIndex, data);
    }
  }

  const handleCloseErrorModal = () => {
    setErrorModal(false);
  }

  return (
    <div className='container' aria-atomic>
      <AudioLoadingDescription loading={loadingData || loadingBoleto} />
      <LoadingApp showLoading={loadingBoleto} />
      <PageTitle text="2ª via de boleto" />

      <Typography style={accessibility.textStyleAccessibility}  sx={{fontSize: '16px', color: '#4C4C4C', marginBottom: 0}}>
        Apenas serão exibidos boletos:
      </Typography>
      
      <ul  style={{ marginTop: 0, marginBottom: '16px', color: '#4C4C4C', paddingLeft: '20px'}}>
        <li>para a pessoa pagadora do contrato;</li>
        <li>se o boleto ainda não foi pago;</li>
        <li>até três mensalidades em aberto;</li>
        <li>boletos negociados (parcelamentos) não são exibidos no portal.</li>
      </ul>
      
      <Typography style={accessibility.textStyleAccessibility} sx={{ ...sxSubtitleBold}}>
        {'O boleto seaberto em uma nova janela. Caso tenha dificuldades, desabilite o bloqueador de pop-ups do seu navegador e tente novamente.'}
      </Typography>

      <AdviceContainer content={[
        { text: adviceTextMessage, type: TextTypeEnum.Regular },
        { text: 'O boleto válido para pagamento será sempre o que emitiu por último aqui no portal.', type: TextTypeEnum.Bold }
      ]} />
      {
        loadingData &&
        <CircularProgressLoading/>
      }

      {!loadingData && !permiteEmissao &&
        <div>
          <Typography style={accessibility.textStyleAccessibility} sx={{ ...sxSubtitleBold, marginTop: '25px', marginBottom: '15px' }} tabIndex={0}>{'Emissão de boletos não permitida.'}</Typography>
        </div>
      }

      {
        !loadingData && permiteEmissao &&
        <>
          {
            tipoBoleto === TypeBoletoSegundaVia.Parcelas &&
            <Box>
              <div>
                <Typography style={accessibility.textStyleAccessibility} sx={{ ...sxSubtitleBold, marginTop: '25px', marginBottom: '15px' }} tabIndex={0}>{'Selecione abaixo as mensalidades que deseja pagar:'}</Typography>
                <TabelaFaturas data={parcelas} index={index} onIndexChange={handleIndexChange} />
              </div>

              <div className="data-e-total-container">
                <div className="input-data-container">
                  <Typography tabIndex={0} style={accessibility.textStyleAccessibility} sx={sxLabelDataPagamento}><b>Data de pagamento do boleto</b> (dd/mm/aaaa)</Typography>
                  <div className="filter-item">
                    <TextField
                      tabIndex={0}
                      variant="outlined"
                      id="outlined-start-adornment"
                      fullWidth
                      onChange={handleDateTyped}
                      value={dataDigitada}
                      placeholder="01/01/2000"
                      sx={{
                        '& .MuiOutlinedInput-root': {
                          backgroundColor: accessibility.contrastMode ? 'black' : '',
                          '& fieldset': {
                            borderColor: accessibility.contrastMode ? 'white' : '',
                          },
                        },
                      }}
                      inputProps={{ style: { color: accessibility.contrastMode ? 'white' : '' } }}
                      InputProps={{
                        endAdornment: <InputAdornment position="end">
                          <FontAwesomeIcon style={{ color: accessibility.contrastMode ? 'white' : '' }} onClick={() => { setShowCalendarModal(true); }} className='calendar-icon' icon={faCalendar} />
                        </InputAdornment>,
                      }}
                    />
                  </div>
                </div>
                <div className="valor-total-container">
                  <Typography style={accessibility.textStyleAccessibility} sx={{ ...sxValorTotal }}>Valor total atualizado das mensalidades selecionadas:</Typography>
                  {
                    loadingSelecaoParcelas &&
                    <CircularProgress size="1.5rem" />
                  }
                  {
                    !loadingSelecaoParcelas &&
                    <Typography style={accessibility.textStyleAccessibility} sx={{ ...sxValorTotal, textWrap: 'nowrap' }}><b>{formatNumberToReais(valorTotal)}</b></Typography>
                  }
                </div>
              </div>


              <Button disabled={false} variant='contained' style={accessibility.buttonStyleAccessibility} sx={sxButtonGerarBoleto} onClick={() => gerarBoletoParcelas()}>
                <Typography style={accessibility.buttonTextStyleAccessibility}>Gerar boleto</Typography>
              </Button>
            </Box>
          }

          {tipoBoleto === TypeBoletoSegundaVia.Unico &&
            <div>
              <Typography style={accessibility.textStyleAccessibility} sx={{ ...sxSubtitleBold, marginTop: '25px', marginBottom: '25px' }}>Copie o código de barras ou gere o boleto:</Typography>

              <div className='codigo-barras-container' style={{ ...accessibility.contrastStyle, ...accessibility.contrastBorderAccessibility }}>
                <div className='codigo-barras-text'>
                  <Typography style={accessibility.textStyleAccessibility} sx={sxCodigoDeBarrasValor}>{boleto ? formatStringToReais(boleto.valor) : ''}</Typography>
                  <Typography style={accessibility.textStyleAccessibility} sx={{ ...sxSubtitle, marginTop: '5px', marginBottom: '25px' }}>VENCIMENTO: {boleto ? boleto.dtVencimento : ''}</Typography>
                  <Typography style={accessibility.textStyleAccessibility} sx={{ ...sxSubtitle, marginBottom: '5px' }}>Utilize o número do código de barras abaixo para realizar o pagamento:</Typography>
                  <Typography style={accessibility.textStyleAccessibility} sx={sxSubtitleBold}>{boleto ? boleto.linhaDigitavel : ''}</Typography>
                  <Button
                    type='button'
                    variant='outlined'
                    style={accessibility.buttonStyleAccessibility}
                    sx={sxButtonCopiarCodigoOutlined}
                    onClick={() => { navigator.clipboard.writeText(boleto?.linhaDigitavel ? boleto.linhaDigitavel : '') }}
                    disabled={false}
                  >
                    <Typography style={accessibility.buttonTextStyleAccessibility}>Copiar código</Typography>
                  </Button>
                </div>
              </div>

              <Button disabled={false} variant='contained' sx={sxButtonGerarBoleto} style={accessibility.buttonStyleAccessibility} onClick={() => gerarBoletoUnico()}>
                <Typography style={accessibility.buttonTextStyleAccessibility}>Gerar boleto</Typography>
              </Button>
            </div>
          }

          {(tipoBoleto === TypeBoletoSegundaVia.Vazio || tipoBoleto === TypeBoletoSegundaVia.Erro) &&
            <Typography style={accessibility.textStyleAccessibility} sx={sxSubtitleBold}>Boleto(s) indisponível(is) para emissão. Em caso de dúvidas, entre em contato: (19) 3731-7900.</Typography>
          }
        </>
      }

      <ModalFeedBack
        showModal={errorModal}
        handleShowModal={handleCloseErrorModal}
        icon={'error'}
        textButton={''}
        title={'Atenção'}
        subTitle={errorMessage}
      />

      <CalendarModal
        open={showCalendarModal}
        selectedDate={data}
        handlePickDate={handlePickDate}
        handleCloseModal={() => { setShowCalendarModal(false) }}
      />
    </div>
  );
}

function SegundaViaBoleto() {
  const useNewVersion = isNewSegundaViaBoletoActive();

  if (useNewVersion) {
    return <SegundaViaBoletoNovo />;
  }
  
  return <SegundaViaBoletoLegado />;
}

export default SegundaViaBoleto;